import { useEffect } from 'react'
import { RadioGroup } from 'entities/RadioGroup'
import { useConfigStore } from 'shared/store/configSlice'
import { appThemeOptions } from './options'

export const ThemeSelectorTR = () => {
  const isConfigLoaded = useConfigStore().isConfigLoaded
  const appTheme = useConfigStore().config?.tableReservationConfig?.appTheme
  const updateTableReservationConfig = useConfigStore().updateTableReservationConfig

  useEffect(() => {
    if (!appTheme && isConfigLoaded) {
      updateTheme(appThemeOptions?.[0]?.value)
    }
  }, [appTheme, isConfigLoaded])

  const updateTheme = (value: string) => {
    updateTableReservationConfig({ appTheme: value as 'light' })
  }

  return (
    <RadioGroup
      key={`theme_Selector${appTheme}`}
      options={appThemeOptions}
      value={appTheme}
      handleChange={updateTheme}
      title='Theme'
      sx={{
        width: '720px',
        display: 'grid',
        gap: '10px',
        gridTemplateColumns: 'repeat(auto-fill, 233px)'
      }}
    />
  )
}
